
<div class="mat-typography">
  <mat-form-field class="w-full" [class.table-context]="stylingContextTable" floatLabel="always">
    <mat-label class="input-label">{{label || ''}}</mat-label>
    <mat-select [id]="id" [(ngModel)]="selectedValues" [multiple]="true" [sortComparator]="selectSorter" (focus)="open()" [disabled]="disabled"  [placeholder]="placeholder || label">
      @for (val of values; track val) {
        <mat-option [class.table-context-select]="stylingContextTable" (click)="onItemSelect(val)" [value]="val.id">{{val.value}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>